import { render, staticRenderFns } from "./AdminNotice.vue?vue&type=template&id=4e360708&"
import script from "./AdminNotice.vue?vue&type=script&lang=js&"
export * from "./AdminNotice.vue?vue&type=script&lang=js&"
import style0 from "./AdminNotice.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports